module.exports = __webpack_public_path__ + "static/media/img_overpaper2@3x.d99cd7e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@3x/img_overpaper2@3x.png
// module id = 962
// module chunks = 0